import { CorreoElectronico } from '@rpe/registro-personas-empresas-lib';
import { Telefono } from '../../contactos/telefonos/telefonos.model';
import {
  DireccionGeografica,
  createEmptyDireccionGeografica
} from '../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';

export interface Deposito {
  id: number;
  nombre: String;
  entidad_productiva_id: number;
  direccion_geografica: DireccionGeografica;
  telefonos: Telefono[];
  correos_electronico: CorreoElectronico[];
}

export function createEmptyDeposito(): Deposito {
  return {
    id: null,
    nombre: null,
    entidad_productiva_id: null,
    direccion_geografica: createEmptyDireccionGeografica(),
    correos_electronico: null,
    telefonos: null
  };
}

export function createDeposito(props: any): Deposito {
  return {
    ...createEmptyDeposito(),
    ...props
  };
}

export interface DepositosFormInput {
  depositos: Deposito[];
  // actividad_id: number
}
